/* eslint-disable max-len */

// Urls
export const AWM_EULA_LINK = 'https://cas.teradici.com/EULA.pdf';
export const PRIVACY_STATEMENT_LINK = 'http://www.hp.com/go/privacy';
export const UNAPPROVED_TENANT_REDIRECT_LINK =
  'https://reinvent.hp.com/Anyware-for-windows365';
export const UNAPPROVED_TENANT_REDIRECT_SECONDS = 20;

export const LOGOUT_LINK = '/app/logout';
export const DASHBOARD_LINK = '/app/dashboard';
export const WORKSTATIONS_LINK = '/app/cloudpc';
export const AD_USERS_LINK = '/app/users';

// Home page text
export const PAGE_TITLE = 'Welcome to HP Anyware for Windows 365 solution.';
export const HOME_PAGE_INFO_TEXT =
  'Automate provisioning, manage cloud compute costs and broker secure connections to Windows 365.';

export const BACKEND_ERROR_MESSAGE =
  'An error occurred in our backend, please try again. This failure has been logged so we can improve performance.';

export const DEVELOPMENT = 'development';
export const PRODUCTION = 'production';
export const STAGING = 'staging';

// User Roles
export const ROLE_ADMINISTRATOR = 'administrator';
export const ROLE_USER = 'user';
export const ROLE_USER_ADMIN = 'user_admin';
